function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 11c0-.364.097-.706.268-1H10.5A1.5 1.5 0 019 8.5V2.017a7.5 7.5 0 000 14.967V15a2 2 0 013-1.732V13a2 2 0 013-1.732V11zm-5-8.983V8.5a.5.5 0 00.5.5h6.484A7.501 7.501 0 0010 2.017zM16 11a1 1 0 112 0v7a1 1 0 11-2 0v-7zm-6 4a1 1 0 112 0v3a1 1 0 11-2 0v-3zm3-2a1 1 0 112 0v5a1 1 0 11-2 0v-5z"
});

function SvgReportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgReportIcon;